import React from 'react';
import PlayerIdentity from '../../shared/PlayerIdentity';
import WWIcon from '../../shared/assets/WW.png';
import MarketValueCell from './MarketValueCell';

const RosterPlayerRow = ({ player }) => {
    return (
      <tr>
        <td className="name-td">
            <PlayerIdentity
                player={player}
                icon={player.player_added ? WWIcon : undefined}
            />
        </td>
        <td>{player.salary}</td>
        <MarketValueCell value={player.auction_value} />
        <td>{player.contract_length}</td>
      </tr>
    );
};

export default RosterPlayerRow;
